module.exports = __webpack_public_path__ + "img/member-icon1-02.1a7f1494.png";